import React, { useEffect, useRef } from "react";
import * as echarts from "echarts/core";
import { PieChart as EPieChart } from "echarts/charts";
import { TooltipComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
// import { formatNumberWithIntl } from '@wavvest/shared-utils'

echarts.use([EPieChart, TooltipComponent, CanvasRenderer]);

export type PieChartDataProps = {
  value: number;
  name: string;
  itemStyle: { color: string };
}[];

export type PieChartProps = {
  name: string;
  data: PieChartDataProps;
  total: number;
  radius?: {
    min: string;
    max: string;
  };
  themeColors: {
    backgroundColor: string;
    textColor: string;
    lightColor: string;
  };
  onBarSelect?: (data: { name: string; value: number }) => void;
};

const PieChart: React.FC<PieChartProps> = ({
  name,
  data,
  total,
  radius = {
    min: "65%",
    max: "95%",
  },
  themeColors,
  // onBarSelect,
}) => {
  const chartRef = useRef<HTMLDivElement>(null),
    chartInstanceRef = useRef<echarts.ECharts | null>(null);
  // res = formatNumberWithIntl({ num: total });

  useEffect(() => {
    const handleResize = () => {
      chartInstanceRef.current?.resize();
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      chartInstanceRef.current?.resize();
    });
    if (chartRef.current) {
      resizeObserver.observe(chartRef.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (chartRef.current && !chartInstanceRef.current) {
      chartInstanceRef.current = echarts.init(chartRef.current);
      chartInstanceRef.current.setOption({
        backgroundColor: themeColors.backgroundColor,
        tooltip: {
          trigger: "item",
          // formatter: '{b}: {c} %'
        },
        series: [
          {
            name: name,
            type: "pie",
            radius: [radius.min, radius.max],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: "#000000",
              borderWidth: 1,
            },
            label: {
              show: false,
              // position: 'center',
              // fontSize: 20,
              // fontWeight: 'bold'
              // show: true, // 显示在圆环中心
              position: "center",
              fontSize: 20,
              fontWeight: "bold",
              // formatter: `{total|Total}\n{value|${res}}`, // 显示 total 和总和
              // rich: {
              //   total: {
              //     fontSize: 20,
              //     fontWeight: 400,
              //     color: themeColors.textColor,
              //     lineHeight: 30, // 设置行高
              //   },
              //   value: {
              //     fontSize: 28,
              //     fontWeight: 'bold',
              //     color: themeColors.lightColor,
              //     lineHeight: 40, // 设置行高
              //   },
              // },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
          },
        ],
      });
    }
  }, [data, name, total, themeColors, radius]);

  return (
    <div
      className="pie-chart"
      ref={chartRef}
      style={{ width: "100%", height: 264 }}
    />
  );
};

export default PieChart;
